"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var React = require("react");
var Text = (function (_super) {
    __extends(Text, _super);
    function Text(props) {
        return _super.call(this, props) || this;
    }
    Text.prototype.render = function () {
        var _a = this.props, _b = _a.textContent, textContent = _b === void 0 ? '' : _b, width = _a.width, height = _a.height, _c = _a.fontSize, fontSize = _c === void 0 ? 12 : _c, _d = _a.fontFamily, fontFamily = _d === void 0 ? 'arial' : _d, fontStyle = _a.fontStyle, fontWeight = _a.fontWeight, _e = _a.color, color = _e === void 0 ? '#141414' : _e;
        var lines = textContent.split('\n');
        var lineSpacing = 2; // In px
        var style = {
            fontSize: fontSize + "px",
            fontFamily: fontFamily,
            fontStyle: fontStyle,
            fontWeight: fontWeight
        };
        var SVGText = lines.map(function (content, i) {
            return React.createElement("text", { key: "text-line-" + i, textAnchor: "middle", style: style, fill: color, dy: 
                /* Add an extra offset of the fontSize (plus a spacer) for each line*/
                lines.length > 1 ? (fontSize + lineSpacing) * i : fontSize }, content);
        });
        var SVGTextHeight = (lines.length > 1 ?
            (fontSize + lineSpacing) * lines.length : fontSize);
        var shiftX = width / 2;
        var shiftY = SVGTextHeight / 2;
        return (React.createElement("g", { transform: "translate(" + shiftX + "," + shiftY + ")" }, SVGText));
    };
    return Text;
}(React.Component));
exports.Text = Text;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9LYWF2aW8vY29tcG9uZW50cy9UZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBLDZCQUErQjtBQUcvQjtJQUEwQix3QkFBeUI7SUFFL0MsY0FBWSxLQUFnQjtlQUN4QixrQkFBTSxLQUFLLENBQUM7SUFDaEIsQ0FBQztJQUVELHFCQUFNLEdBQU47UUFDVSxJQUFBLGVBQzZCLEVBRDVCLG1CQUFnQixFQUFoQixxQ0FBZ0IsRUFBRSxnQkFBSyxFQUFFLGtCQUFNLEVBQUUsZ0JBQWEsRUFBYixrQ0FBYSxFQUFFLGtCQUFvQixFQUFwQix5Q0FBb0IsRUFBRSx3QkFBUyxFQUFFLDBCQUFVLEVBQzlGLGFBQWlCLEVBQWpCLHNDQUFpQixDQUFlO1FBQ3BDLElBQU0sS0FBSyxHQUFHLFdBQVcsQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDdEMsSUFBTSxXQUFXLEdBQUcsQ0FBQyxDQUFDLENBQUMsUUFBUTtRQUUvQixJQUFNLEtBQUssR0FBRztZQUNWLFFBQVEsRUFBSyxRQUFRLE9BQUk7WUFDekIsVUFBVSxZQUFBO1lBQ1YsU0FBUyxXQUFBO1lBQ1QsVUFBVSxZQUFBO1NBQ2IsQ0FBQztRQUVGLElBQU0sT0FBTyxHQUFHLEtBQUssQ0FBQyxHQUFHLENBQUMsVUFBQyxPQUFPLEVBQUUsQ0FBQztZQUNqQyxPQUFBLDhCQUFNLEdBQUcsRUFBRSxlQUFhLENBQUcsRUFDckIsVUFBVSxFQUFDLFFBQVEsRUFDbkIsS0FBSyxFQUFFLEtBQUssRUFDWixJQUFJLEVBQUUsS0FBSyxFQUNYLEVBQUU7Z0JBQ0Usc0VBQXNFO2dCQUN0RSxLQUFLLENBQUMsTUFBTSxHQUFHLENBQUMsR0FBRyxDQUFDLFFBQVEsR0FBRyxXQUFXLENBQUMsR0FBQyxDQUFDLEdBQUcsUUFBUSxJQUVoRSxPQUFPLENBQVE7UUFSakIsQ0FRaUIsQ0FDcEIsQ0FBQztRQUVGLElBQU0sYUFBYSxHQUFXLENBQUMsS0FBSyxDQUFDLE1BQU0sR0FBRyxDQUFDO1lBQzNDLENBQUMsUUFBUSxHQUFHLFdBQVcsQ0FBQyxHQUFDLEtBQUssQ0FBQyxNQUFNLEdBQUcsUUFBUSxDQUFDLENBQUM7UUFFdEQsSUFBTSxNQUFNLEdBQVcsS0FBSyxHQUFHLENBQUMsQ0FBQztRQUNqQyxJQUFNLE1BQU0sR0FBVyxhQUFhLEdBQUcsQ0FBQyxDQUFDO1FBRXpDLE1BQU0sQ0FBQyxDQUNILDJCQUFHLFNBQVMsRUFBRSxlQUFhLE1BQU0sU0FBSSxNQUFNLE1BQUcsSUFDekMsT0FBTyxDQUNSLENBQ1AsQ0FBQTtJQUNMLENBQUM7SUFDTCxXQUFDO0FBQUQsQ0FBQyxBQTNDRCxDQUEwQixLQUFLLENBQUMsU0FBUyxHQTJDeEM7QUEzQ1ksb0JBQUkifQ==


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/Kaavio/components/Text.js
// module id = 474
// module chunks = 0